<template>
  <Popover :placement="placement" :open="open" @close="$emit('close')" v-bind="$attrs" v-on="$listeners">
    <slot name="reference" slot="reference" />
    <ul class="list-none">
      <slot />
    </ul>
  </Popover>
</template>

<script>

export default {
  name: 'Menu',

  props: { 
    open: Boolean,
    placement: {
      type: String,
      default: 'bottom-start'
    }
  },

  data () {
    return {
      internalOpen: false
    }
  },

  computed: {
    sourceOfTruthOpen () {
      if (this.open) { 
        return this.open 
      }
      return this.internalOpen
    }
  }
}

</script>
